import styled from '@emotion/styled';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import Button from '@mui/material/Button';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useStockTakeTableColumns = (getReport, apiRef) => {
  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    {
      field: 'type',
      headerName: 'نوع',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    {
      field: 'agent',
      headerName: 'کاربر',
      flex: 1,
      minWidth: 60,
      resizable: true,
      editable: false,
    },
    {
      field: 'shortCode',
      headerName: 'کد',
      flex: 1,
      minWidth: 60,
      resizable: true,
      editable: false,
    },
    {
      field: 'createTime',
      headerName: 'زمان ساخت',
      flex: 1,
      minWidth: 60,
      resizable: true,
      editable: false,
    },

    {
      field: 'actions',
      headerName: 'عملیات',
      type: 'actions',
      flex: 1,
      minWidth: 300,
      getActions: params => [
        <TableActionButtons
          key={10}
          buttons={[
            {
              label: 'دانلود گزارش',
              Icon: InfoIcon,
              onClick: getReport(params.row),
              color: 'primary',
            },
            // {
            //   label: 'گراف',
            //   Icon: SsidChartIcon,
            //   onClick: goToGraphPage(params.row),
            //   color: 'warning',
            // },
            // {
            //   label: 'ویرایش',
            //   Icon: ModeEditOutlineIcon,
            //   onClick: editItem(params.row),
            //   color: 'info',
            // },
          ]}
        />,
        // <GridActionsCellItem
        //   key={3}
        //   icon={<DeleteIcon />}
        //   label="حذف"
        //   onClick={deleteItem(params.row)}
        //   showInMenu
        // />,
      ],
    },
  ];

  return [columnsData];
};

export default useStockTakeTableColumns;

const ColImage = styled.img`
  object-fit: fill;
  max-width: 60px;
  max-height: 90%;
`;
